import { create } from 'zustand';

const newSessionId = () => crypto.randomUUID();

const DEFAULT_VARIABLES = {
  user: {
    name: 'Demo User',
    email: 'demo@example.com',
    phone: '+1234567890',
    location: 'San Francisco'
  }
};

export const useChatStore = create((set) => ({
  history: [],
  currentNodeId: null,
  status: 'idle',
  variables: DEFAULT_VARIABLES,
  aiConversationHistory: [],
  sessionId: newSessionId(),
  visitedNodeIds: [],

  setHistory: (history) => set({ history }),
  addHistoryItem: (item) => set((state) => ({ history: [...state.history, item] })),
  setCurrentNodeId: (id) => set({ currentNodeId: id }),
  addVisitedNodeId: (id) => set((state) => {
    if (state.visitedNodeIds.includes(id)) return {};
    return { visitedNodeIds: [...state.visitedNodeIds, id] };
  }),
  setStatus: (status) => set({ status }),
  setVariables: (variables) => set({ variables }),
  updateVariable: (name, value) => set((state) => ({
    variables: { ...state.variables, [name]: value }
  })),
  setAiConversationHistory: (aiConversationHistory) => set({ aiConversationHistory }),
  resetChat: () => set({
    history: [],
    currentNodeId: null,
    status: 'idle',
    variables: DEFAULT_VARIABLES,
    aiConversationHistory: [],
    sessionId: newSessionId(),
    visitedNodeIds: [],
  }),
}));
